import Vue from "vue";
import Router from "vue-router";
import { store } from '../_store';

import Home from '../views/Home.vue';
import Gifts from '../components/gifts/Gifts.vue'

const jwt = require('jsonwebtoken')
import { jwtConfig } from '../_configs'

Vue.use(Router);

export const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/gifts",
      name: "gifts",
      component: Gifts
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in
  const publicPages = ['/']
  const authRequired = !publicPages.includes(to.path)
  const theToken = localStorage.getItem('ben-token')
  const currentTime = Date.now().valueOf() / 1000
  let loggedIn = false

  // if there is a token, check if it is expired
  // if it not expired then the user is still logged in
  // if it is expired then set the user to logged out

  if(theToken || theToken !== typeof undefined) {
    jwt.verify(theToken, jwtConfig.default.secret, function(err, decoded){
      if(!err) {
        if(decoded.exp > currentTime) {
          loggedIn = true
          store.dispatch('authentication/reLogIn', { reload: true })
        } else {
          alert('Session timed out. You are being logged out.')
          store.dispatch('authentication/logout', { action: 'Log Out - Timeout'})
          loggedIn = false
          return next('/')
        }
      }
    })
  }
  if(authRequired && !loggedIn) {
    if(theToken) {
      alert('Session timed out. You are being logged out.')
      store.dispatch('authentication/logout', { action: 'Log Out - Timeout'})
      loggedIn = false
    }
    return next('/')
  }

  next()
})